import {Component, computed, effect, inject, input} from '@angular/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {TodoStatusSelect} from '../../../../../api';
import {Dot} from '../../../../components/dot/dot';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {TodoQueryService} from '../../services/todo-query.service';

@Component({
  selector: 'elcia-todo-status-dropdown',
  imports: [
    Dropdown,
    MultiDropdown,
    Dot,
    TranslatePipe,
  ],
  templateUrl: './todo-status-dropdown.html',
  styleUrl: './todo-status-dropdown.scss',
})
export class TodoStatusDropdown {
  isMulti = input(false);
  control = input.required<FormControl>();
  private readonly queryService = inject(TodoQueryService);
  statuses = computed<TodoStatusSelect[]>(() => this.queryService.statuses());
  onControlAndDataLoaded = effect(() => {
    if (!this.control().value && this.statuses().length > 0) {
      const defaultStatus = this.statuses().find(s => s.isDefault);
      this.control().setValue(defaultStatus?.id);
    }
  })
}
